var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"w-full pb-20 space-y-4"},[_c('Restricted',{attrs:{"permission":"user.invite"}},[_c('MemberInvitationSection')],1),_c('MemberListSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }